import React, { useState, useEffect } from "react";

const Footer: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 620);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 620);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const linkStyle = {
    background: "none",
    border: "none",
    color: "#ffffff",
    fontSize: "16px",
    padding: "0",
    textAlign: "left" as const,
    cursor: "pointer",
    transition: "color 0.3s ease",
  };

  const contactLinkStyle = {
    color: "#04EEAD",
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "500",
    transition: "opacity 0.3s ease",
    textAlign: "left" as const,
  };

  return (
    <footer
      style={{
        backgroundColor: "#2D3748",
        paddingTop: isMobile ? "60px" : "80px",
        paddingBottom: isMobile ? "40px" : "60px",
        paddingLeft: isMobile ? "16px" : "40px",
        paddingRight: isMobile ? "16px" : "40px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr 1fr 1fr",
            gap: isMobile ? "40px" : "60px",
            marginBottom: isMobile ? "40px" : "60px",
          }}
        >
          {/* Brand Section */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <div style={{ marginBottom: "16px" }}>
              <h2
                style={{
                  fontSize: isMobile ? "24px" : "28px",
                  fontWeight: "bold",
                  color: "#ffffff",
                  margin: "0",
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                }}
              >
                Etiti<span style={{ color: "#04EEAD" }}>Logistics</span>
              </h2>
              <p
                style={{
                  fontSize: "12px",
                  color: "#9CA3AF",
                  margin: "4px 0 0 0",
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                  textAlign: "left",
                }}
              >
                Registered RC 1448149
              </p>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "8px",
                marginTop: "24px",
              }}
            >
              <span style={{ color: "#9CA3AF", fontSize: "16px", marginTop: "2px" }}>📍</span>
              <div>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#9CA3AF",
                    margin: "0 0 4px 0",
                    fontWeight: "500",
                    textAlign: "left",
                  }}
                >
                  Located at
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#ffffff",
                    margin: "0",
                    lineHeight: "1.5",
                    textAlign: "left",
                  }}
                >
                   Road 10, Lekki Scheme 2,
                  <br />
                 Lekki Ajah, Lagos
                </p>
              </div>
            </div>
          </div>

          {/* Contact Us Section */}
           <div>
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#9CA3AF",
                margin: "0 0 24px 0",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                textAlign: "left",
              }}
            >
              Contact Us
            </h3>

            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <a
                href="tel:+2347058775889"
                style={contactLinkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
               +234 705 877 5889
              </a>
              <a
                href="tel:+447565744538"
                style={contactLinkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
                +44 7565 744538
              </a>

              {/* <a
                href="mailto:uekeledo@gmail.com"
                style={contactLinkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
                uekeledo@gmail.com
              </a> */}
            </div>
          </div> 

          {/* Company Section */}
          <div>
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#9CA3AF",
                margin: "0 0 24px 0",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                textAlign: "left",
              }}
            >
              Company
            </h3>

            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <button
                onClick={() => scrollToSection("hero")}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#ffffff")}
              >
                About Us
              </button>

              <button
                onClick={() => scrollToSection("our-services")}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#ffffff")}
              >
                Our Services
              </button>

              <button
                onClick={() => scrollToSection("contact")}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#ffffff")}
              >
                Contact
              </button>
            </div>
          </div>

          {/* Services Section */}
          <div>
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#9CA3AF",
                margin: "0 0 24px 0",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                textAlign: "left",
              }}
            >
              Services
            </h3>

            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <button
                onClick={() => scrollToSection("food-agro-export")}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#ffffff")}
              >
                Food & Agro Export
              </button>

              <button
                onClick={() => scrollToSection("warehousing")}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#ffffff")}
              >
                Warehousing
              </button>

              <button
                onClick={() => scrollToSection("cargo-delivery")}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#ffffff")}
              >
                Cargo Delivery
              </button>
               <button
                onClick={() => scrollToSection("cargo-delivery")}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#ffffff")}
              >
                Product Sourcing
              </button>
               <button
                onClick={() => scrollToSection("cargo-delivery")}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#ffffff")}
              >
                Personal Shopping
              </button>
            </div>
          </div>
        </div>

        <div
          style={{
            height: "1px",
            backgroundColor: "#4B5563",
            marginBottom: "24px",
          }}
        />

        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontSize: "14px",
              color: "#9CA3AF",
              margin: "0",
            }}
          >
            © Etiti. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
